/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef, useMemo } from 'react';
import { authHeaders, axiosInstance, isEmptyData } from '../../utils/helper';
import { apiUrlB2B, companyColors } from '../../utils/constants';
import qs from 'qs';
import useNavigation from '../../hook/useNavigation';
import { useDispatch, useSelector } from 'react-redux';
import { setCompany } from '../../store/reducers/ufood-x/company';
import { setColor } from '../../store/reducers/color';
import { setUser } from 'store/reducers/user';

const useIdentifyCompany = () => {
	const dispatch = useDispatch();
	const navigate = useNavigation();
	const [isLoading, setIsLoading] = useState(false);
	const company = useSelector((store) => store?.company);
	const url = new URL(window.location.href);
	const companyUrl = url.origin;
	const pathname = window.location.pathname;

	const handleIdentify = async () => {
		try {
			setIsLoading(true);
			const payload = {
				companyUrl: companyUrl,
			};
			const res = await axiosInstance.post(`${apiUrlB2B}auth-ufoodx/indentify-company`, qs.stringify(payload), authHeaders());
			if (res?.data?.statusCode === 200) {
				const result = res?.data?.data;

				const colorCompany = (typeof result?.companyColor === 'string' ? JSON.parse(result?.companyColor) : result?.companyColor) || companyColors;
				dispatch(setColor(colorCompany));

				const companyData = {
					companyID: result?.companyId,
					companyURL: result?.companyURL,
					companyName: result?.companyName,
					companyLogo: result?.companyLogo,
					brandId: result?.brandId,
					companyLoyaltyPassword: result?.companyLoyaltyPassword,
					companyLoyaltyUrl: result?.companyLoyaltyUrl,
					companyLoyaltyUsername: result?.companyLoyaltyUsername,
					loyalty: result?.loyalty,
					companyLoyaltyWidgetUrl: result?.companyLoyaltyWidgetUrl,
					companyLoyaltyClientCode: result?.companyLoyaltyClientCode,
					isIdentified: true
				};
				dispatch(setCompany(companyData));

        if (!isEmptyData(result?.googleAnalytic)) {
          dispatch(setUser({ googleAnalytic: result?.googleAnalytic }));          
        }
			}
			setIsLoading(false);
		} catch (error) {
			console.log('identify company error:', error);
			dispatch(setCompany({ isIdentified: true }));
			setIsLoading(false);
		}
	};

	const isCompletedData = useMemo(() => {
		return !isEmptyData(company?.companyLoyaltyUrl) && !isEmptyData(company?.companyLoyaltyWidgetUrl) && !isEmptyData(company?.companyLoyaltyUsername) && !isEmptyData(company?.companyLoyaltyPassword) && !isEmptyData(company?.companyLoyaltyClientCode);
	}, [company?.companyLoyaltyUrl, company?.companyLoyaltyWidgetUrl, company?.companyLoyaltyUsername, company?.companyLoyaltyPassword, company?.companyLoyaltyClientCode]);

	useEffect(() => {
		if (company?.isIdentified) return;
		if (!isCompletedData) {
			handleIdentify();
		}
	}, [isCompletedData]);

	useEffect(() => {
		if (company?.companyID && company?.companyURL === companyUrl && pathname === '/') {
			navigate.replace('/ufood-x');
		}
	}, [company]);

	useEffect(() => {
		if (isEmptyData(companyUrl)) {
			setIsLoading(false);
		}
	}, []);

	return { isLoading };
};

export default useIdentifyCompany;
